var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgControl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "104px",
    height: "118px",
    viewBox: "0 0 104 118",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 23") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M32,0 C49.673112,0 64,14.360362 64,32.0747664 C64,41.7358195 59.7386452,50.3992543 52.9971751,56.2796696 L32.0500895,78 L11.048967,56.3198412 C4.28080533,50.4387475 0,41.7578428 0,32.0747664 C0,14.360362 14.326888,0 32,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-53.1%",
    y: "-33.3%",
    width: "206.2%",
    height: "187.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 8,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-37.5%",
    y: "-37.5%",
    width: "175.0%",
    height: "175.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u65B0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7AD9\\u70B9\\u5730\\u56FE3\\u5907\\u4EFD",
    transform: "translate(-191.000000, -457.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-23",
    transform: "translate(211.000000, 469.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5F62\\u72B6\\u7ED3\\u5408"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#66CB04",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u793E\\u533A\\u77EB\\u6B63\\u5907\\u4EFD",
    filter: "url(#filter-3)",
    transform: "translate(16.000000, 16.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7710631,7.42991303 C27.755675,7.73087832 28.6871492,7.85188958 29.5409261,7.85188958 C30.4478408,7.85188958 31.2721463,7.71614263 32,7.51743409 L32,1.82320662 C31.3114414,2.19651074 29.8561805,2.75959268 28.0374393,2.20633453 C26.4901919,1.73613209 25.234086,1.50304028 24.2057136,1.43070145 L24.2057136,0.935939522 C24.2057136,0.417064654 23.7882024,0 23.2791513,0 C22.7696537,0 22.352589,0.42197655 22.352589,0.935939522 L22.352589,8.31762666 L17.3670142,3.28337944 C17.0079993,2.91945257 16.5083255,2.70645489 15.9992744,2.70645489 C15.4803995,2.70645489 14.9954614,2.91007532 14.6315345,3.27846754 L0.265577305,17.7998193 C-0.0885257683,18.1583877 -0.0885257683,18.7357588 0.265577305,19.0947738 L0.532605852,19.3613558 C0.702289544,19.5310395 0.930469456,19.6283843 1.17293852,19.6283843 C1.41049569,19.6283843 1.6435875,19.5310395 1.81818309,19.3613558 L4.06381279,17.0916131 L4.06381279,29.4981702 L3.53020223,29.4981702 C2.84655557,29.4981702 2.28838553,30.0558938 2.28838553,30.7493642 C2.28838553,31.4428347 2.84610903,32.0005582 3.53020223,32.0005582 L28.4790634,32.0005582 C29.1631566,32.0005582 29.7159682,31.4428347 29.7159682,30.7493642 C29.7159682,30.0558938 29.1631566,29.4981702 28.4790634,29.4981702 L27.9458994,29.4981702 L27.9458994,17.0960785 L30.1866172,19.3609093 C30.3563009,19.530593 30.5844808,19.6279378 30.8269498,19.6279378 C31.064507,19.6279378 31.2971523,19.530593 31.4672825,19.3609093 L31.7343111,19.0943272 C32.0884141,18.7353123 32.0884141,18.1583877 31.7343111,17.7993728 L24.2057136,10.1895057 L24.2057136,6.85254194 C24.78755,6.92086195 25.6167674,7.08072185 26.7710631,7.42991303 Z M19.3210559,29.4977237 L12.6765998,29.4977237 L12.6765998,22.3781532 L19.3259678,22.3781532 L19.3259678,29.4981702 L19.3210559,29.4981702 L19.3210559,29.4977237 Z",
    id: "\\u5F62\\u72B6",
    fill: "#FFFFFF"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgControl);
export default __webpack_public_path__ + "static/media/img_control.c05879950329c3bcf9dc6c7599e8647d.svg";
export { ForwardRef as ReactComponent };